
import { fetch } from '@/services/base'

import Transformer from '@/transformers/transformer'

const SinisterTransformer = ({
  affected_count: affectedCount,
  other_processes: otherProcesses,
  verified_data: verifiedData,
  sinister_id: id,
  supervisor,
  sinister_number: sinisterNumber,
  assignment_date: assignmentDate,
  slug

}) => ({
  id,
  sinisterNumber,
  assignmentDate,
  slug,
  affectedCount,
  supervisor,
  otherProcesses,
  verifiedData
})

class SimpleProcessTransformer extends Transformer {
  static fetch({ count, next, previous, pages, results }) {
    return SimpleSinistersTransformer({ count, next, previous, pages, results })
  }
}

const SimpleSinistersTransformer = ({ count, next, previous, pages, results }) =>
  ({ count, next, previous, pages, results: results ? results.map(SinisterTransformer) : [] })

const ProcessTransformer = ({ process, data }) =>
  ({ process, data: data ? SimpleSinistersTransformer(data) : [] })

const CyclesTransformer = ({ cycle, resume }) =>
  ({ cycle, resume: resume ? resume.map(ProcessTransformer) : [] })

class GeneralTransformer extends Transformer {
  static fetch(cycles) {
    return !!cycles && !!cycles.length ? cycles.map(CyclesTransformer) : []
  }
}

const paramsTransformer = ({
  dateFrom, dateTo, supervisors = [], acos = [], customers = [], zones = [], jobTypes = [], searchText, page = 1, pageSize = 10
}) => (
  {
    date_to: dateTo,
    date_from: dateFrom,
    supervisors: supervisors.length ? supervisors.join(',') : undefined,
    acos: acos.length ? acos.join(',') : undefined,
    zones: zones.length ? zones.join(',') : undefined,
    customers: customers.length ? customers.join(',') : undefined,
    job_types: jobTypes.length ? jobTypes.join(',') : undefined,
    searchText: searchText || undefined,
    page: page || undefined,
    pageSize: pageSize || undefined
  }
)

/**
 * Obtain the sinister by process paginated
 * @return {Promise} An http GET request
 */
const fetchSinisters = (process, filters = {}) => {
  let tranformer = SimpleProcessTransformer
  if (process === 'general') {
    tranformer = GeneralTransformer
  }
  return fetch('list/macro_process', {
    useTransformer: tranformer,
    id: process,
    urlGroup: 'sinister',
    config: {
      params: paramsTransformer(filters)
    }
  })
}

export default fetchSinisters
